import { render } from "./dashboardNewsModal.vue?vue&type=template&id=efbe2cd4&scoped=true"
import script from "./dashboardNewsModal.vue?vue&type=script&lang=js"
export * from "./dashboardNewsModal.vue?vue&type=script&lang=js"

import "./dashboardNewsModal.vue?vue&type=style&index=0&id=efbe2cd4&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbe2cd4"]])

export default __exports__